import { AlertTriangle, Smartphone, PhoneOff } from "lucide-react";

const PROBLEMS = [
  {
    icon: AlertTriangle,
    title: "Chaos na stronie",
    body:
      "Przeładowane sekcje, niejasna oferta, brak CTA. Klient wchodzi, nie rozumie i wychodzi.",
  },
  {
    icon: Smartphone,
    title: "Słaby mobile UX",
    body:
      "85% klientów wchodzi z telefonu. Wolne ładowanie, mikro-fonty i klikalne pola wielkości pikseli zabijają konwersję.",
  },
  {
    icon: PhoneOff,
    title: "Trudny kontakt",
    body:
      "Formularz na 8 pól, mail w stopce, telefon ukryty. Lead, który chciał oddzwonić, dzwoni do konkurencji.",
  },
];

export default function AgencyProblem() {
  return (
    <section
      id="problem"
      data-testid="agency-problem"
      className="relative py-20 lg:py-28 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-yellow">
            Dlaczego stare strony PV nie sprzedają
          </div>
          <h2 className="mt-3 font-heading font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            Dobra ekipa.{" "}
            <span className="text-white/40">Strona z 2017.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-white/60 max-w-2xl leading-relaxed">
            Trzy najczęstsze powody, dla których firmy fotowoltaiczne tracą
            leady — zanim w ogóle do nich zadzwonią.
          </p>
        </div>

        <div className="mt-12 lg:mt-16 grid md:grid-cols-3 gap-5 sm:gap-6">
          {PROBLEMS.map(({ icon: Icon, title, body }, i) => (
            <div
              key={title}
              data-testid={`agency-problem-card-${i}`}
              className="group relative rounded-3xl bg-white/[0.03] ring-1 ring-white/10 p-7 lg:p-8 hover:bg-white/[0.05] hover:ring-white/20 transition-all"
            >
              <div className="grid place-items-center h-12 w-12 rounded-2xl bg-brand-yellow/10 ring-1 ring-brand-yellow/30 text-brand-yellow">
                <Icon className="h-6 w-6" />
              </div>
              <h3 className="mt-6 font-heading font-bold text-white text-xl lg:text-2xl tracking-tight">
                {title}
              </h3>
              <p className="mt-3 text-[15px] text-white/60 leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
